import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const doctoralProgramFilters = [
  <TextInput
    label="Име на български език"
    source="nameBg"
    style={{ width: 400 }}
    alwaysOn
  />,
];

const ListDoctoralPrograms = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;
  };

  return (
    <List
      title="Докторантски програми"
      filters={doctoralProgramFilters}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateDoctoralPrograms)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateDoctoralPrograms}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="nameBg" label="Име на български език" sortable={false} />
          <TextField source="nameEn" label="Име на английски език" sortable={false} />
          <SecuredComponent permission={permissions.canUpdateDoctoralPrograms}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDoctoralPrograms;
